import script from "./RatingSkills.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingSkills.vue?vue&type=script&setup=true&lang=js"

import "./RatingSkills.vue?vue&type=style&index=0&id=57ec1fb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ec1fb3"]])

export default __exports__